export const messages = {
  wronggame: {
    title: "Il gioco non esiste",
    message:
      "Questo gioco non esiste. Accedi al pannello dell’allenatore e riprova.",
    event: "wronggame",
  },
  wrongcode: {
    title: "Conflitto di dispositivi",
    message:
      "Probabilmente il gioco è stato avviato su un altro dispositivo. Se vuoi trasferirlo su questo, accedi al pannello dell’allenatore e usa l’opzione corrispondente.",
    event: "wronggcode",
  },
  expired: {
    title: "Gioco terminato",
    message:
      "Probabilmente il tempo per giocare è scaduto. Accedi al pannello dell’allenatore e controlla la tua lista giochi.",
    event: "wronggcode",
  },
  missingcredentials: {
    title: "Dati del gioco mancanti",
    message:
      "Probabilmente stai cercando di avviare il gioco da un link incollato su un altro dispositivo. Accedi al pannello dell’allenatore e avvia il gioco da lì.",
    event: "wronggcode",
  },
  diceTitle: "Lancia un dado e scegli il risultato",
  diceOr: "OPPURE",
};
export const it = {
  tutorial: {
    Vipers: {
      name: "Nido di Vipere",
      effect: "display",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 6,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Ti muovi con cautela tra i cespugli. Senti un fruscio leggero nei cespugli vicini, ma tutto si calma mentre ti allontani lentamente lungo il tuo cammino.",
      badDescription1:
        "Passi accanto ai cespugli vicini, canticchiando per farti coraggio. All’improvviso ti raggiunge un sibilo minaccioso! Prima che tu possa scattare via, una vipera si lancia contro i tuoi polpacci e ti morde dolorosamente.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Shrubbery: {
      name: "Cespugli Spinosi",
      effect: "display/toss",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: 1,
      badKarma3: 1,
      badKarma4: 1,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription1:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription2:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription3:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription4:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription5:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      badDescription6:
        "Lungo il sentiero crescono molte piante spinose, facili da graffiare o ferire. Sei però riuscito a evitare ogni guaio",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
  },
  game: {
    Village: {
      name: "Villaggio della Palude",
      effect: "display",
      protection: "none",
      protectedKarma: 2,
      badKarma1: 2,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Attraversi un villaggio abitato da strane creature. Hanno l’abitudine di lanciare fango puzzolente contro gli estranei. Sanno bene cosa fanno: è davvero difficile togliersi di dosso quell’odore.",
      badDescription1:
        "Attraversi un villaggio abitato da strane creature. Hanno l’abitudine di lanciare fango puzzolente contro gli estranei. Sanno bene cosa fanno: è davvero difficile togliersi di dosso quell’odore.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Swamps: {
      name: "Palude",
      effect: "display",
      protection: "breathing-spell",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Hai messo piede nella palude. L’attraversamento, pur faticoso, procede con relativa calma — solo l’aria è così pesante che ci si potrebbe appendere un’ascia.",
      badDescription1:
        "Hai messo piede nella palude. L’attraversamento, pur faticoso, procede con relativa calma — solo quei vapori pungenti irritano la gola. Non succede nulla di concreto, ma inizi a tossicchiare in modo strano.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Mountains: {
      name: "Monti della Follia",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 7,
      badKarma2: 17,
      badKarma3: 15,
      badKarma4: 18,
      badKarma5: 10,
      badKarma6: 19,
      worseKarma1: 7,
      worseKarma2: 7,
      worseKarma3: 17,
      worseKarma4: 17,
      worseKarma5: 18,
      worseKarma6: 15,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. La mente si annebbia, ma ti avvicini docilmente al bordo e salti. Per salvarti, tuttə devono interrompere le proprie attività e correre in tuo aiuto.",
      badDescription2:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. Ti riprendi all’ultimo istante, ma hai la sensazione che quelle voci resteranno nella tua testa per sempre.",
      badDescription3:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. Ti riprendi all’ultimo istante, ma hai la sensazione che quelle voci resteranno nella tua testa per sempre.",
      badDescription4:
        "I paesaggi montani sono follemente affascinanti. Peccato che, mentre li contemplavi, sei rovinosamente cadutə e ti sei fatto male sul serio.",
      badDescription5:
        "I paesaggi montani sono follemente affascinanti. Peccato che, mentre li contemplavi, sei scivolatə e ti sei tagliatə la guancia su una roccia sporgente.",
      badDescription6:
        "Le montagne come le montagne: l’ambiente è monotono fino alla follia. Hai la sensazione di esserci già passatə più volte. Giri in tondo senza riuscire a trovare la strada giusta.",
      worseDescription1:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. La mente si annebbia, ma ti avvicini docilmente al bordo e salti. Per salvarti, tuttə devono interrompere le proprie attività e correre in tuo aiuto.",
      worseDescription2:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. La mente si annebbia, ma ti avvicini docilmente al bordo e salti. Per salvarti, tuttə devono interrompere le proprie attività e correre in tuo aiuto.",
      worseDescription3:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. Ti riprendi all’ultimo istante, ma hai la sensazione che quelle voci resteranno nella tua testa per sempre.",
      worseDescription4:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. Ti riprendi all’ultimo istante, ma hai la sensazione che quelle voci resteranno nella tua testa per sempre.",
      worseDescription5:
        "I paesaggi montani sono follemente affascinanti. Peccato che, mentre li contemplavi, sei rovinosamente cadutə e ti sei fatto male sul serio.",
      worseDescription6:
        "L’aura di follia ti fa sentire voci che ti spingono a gettarti nel vuoto. Ti riprendi all’ultimo istante, ma hai la sensazione che quelle voci resteranno nella tua testa per sempre.",
    },
    Footbridge: {
      name: "Passerella di Legno",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 8,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Cadi in acqua: la passerella è instabile. Sotto di essa vive un troll dispettoso. Ti trova simpaticə, quindi non ti fa del male e riesci ad attraversare il fiume in sicurezza.",
      badDescription1:
        "Cadi in acqua: la passerella è instabile. Sotto di essa vive un troll dispettoso. Non gli piaci affatto, quindi ti colpisce con una clava — riesci a malapena a trascinarti fino all’altra sponda.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Avalanche: {
      name: "Frana di Massi",
      effect: "display/toss",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 9,
      badKarma2: 9,
      badKarma3: 9,
      badKarma4: 9,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Dal pendio cadono massi proprio sul sentiero, ma riesci a evitare colpi gravi.",
      badDescription1:
        "Dal pendio cadono massi proprio sul sentiero, e uno ti colpisce alla testa. Ti stordisce per bene, e ti spunta un enorme bernoccolo.",
      badDescription2:
        "Dal pendio cadono massi proprio sul sentiero, e uno ti colpisce alla testa. Ti stordisce per bene, e ti spunta un enorme bernoccolo.",
      badDescription3:
        "Dal pendio cadono massi proprio sul sentiero, e uno ti colpisce alla testa. Ti stordisce per bene, e ti spunta un enorme bernoccolo.",
      badDescription4:
        "Dal pendio cadono massi proprio sul sentiero, e uno ti colpisce alla testa. Ti stordisce per bene, e ti spunta un enorme bernoccolo.",
      badDescription5:
        "Dal pendio cadono massi proprio sul sentiero, ma riesci a evitare colpi gravi.",
      badDescription6:
        "Dal pendio cadono massi proprio sul sentiero, ma riesci a evitare colpi gravi.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Generator: {
      name: "Generatore Magico",
      effect: "generator",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: 15,
      badKarma3: 20,
      badKarma4: 10,
      badKarma5: 21,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri saltellano allegre scintille magiche. Ti piacciono: in fondo, raramente si vede qualcosa di così colorato.",
      badDescription1:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti colpisce e all’improvviso non riesci a respirare. Ti manca l’aria, ma dopo qualche secondo passa tutto. Probabilmente niente di grave.",
      badDescription2:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti colpisce e non ricordi più chi sei né dove ti trovi. La memoria vacilla, ma dopo qualche secondo passa tutto. Probabilmente niente di grave.",
      badDescription3:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti colpisce e ti brucia le sopracciglia. Ricresceranno, quindi probabilmente niente di grave.",
      badDescription4:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti colpisce e ti brucia la mano. Guarirà, quindi probabilmente niente di grave.",
      badDescription5:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti colpisce e ti scaraventa all’indietro. Cadi a terra, fa un po’ male, ma probabilmente niente di grave.",
      badDescription6:
        "Attraversi una zona costellata di strane costruzioni. Apparterranno sicuramente ai maghi — si sa che costruiscono cose curiose. Tra i pilastri guizzano scariche e piovono scintille magiche. Una ti sfiora per un soffio.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Glade: {
      name: "Radura del Cacciatore",
      effect: "display",
      protection: "breastplate",
      protectedKarma: 1,
      badKarma1: 10,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Attraversi una radura dove dei cacciatori stanno dando la caccia alla selvaggina. Ti salutano con entusiasmo da lontano.",
      badDescription1:
        "Attraversi una radura dove dei cacciatori stanno dando la caccia alla selvaggina, e proprio accanto a te sfreccia una volpe. Senti un sibilo e una fitta al gluteo — una freccia destinata alla volpe ti ha sfiorato. Per fortuna è solo una ferita superficiale.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Ruins: {
      name: "Rovine Cupi",
      effect: "display",
      protection: "none",
      protectedKarma: 3,
      badKarma1: 3,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Ti addentri tra gli edifici, cercando una scorciatoia verso la tua meta. Schivi con attenzione una torre pericolante — quando all’improvviso, dal nulla, ti salta addosso un vecchio cencioso e ti maledice fino alla quinta generazione! Non riesci a fendere quel muro d’insulti. Te ne vai con la coda tra le gambe, scosso da questo incontro sconvolgente.",
      badDescription1:
        "Ti addentri tra gli edifici, cercando una scorciatoia verso la tua meta. Schivi con attenzione una torre pericolante — quando all’improvviso, dal nulla, ti salta addosso un vecchio cencioso e ti maledice fino alla quinta generazione! Non riesci a fendere quel muro d’insulti. Te ne vai con la coda tra le gambe, scosso da questo incontro sconvolgente.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Forest: {
      name: "Foresta Cupa",
      effect: "display",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Attraversi una foresta che sembra sul punto di vomitarti addosso qualche orrore nascosto. Per fortuna scorgi già uno spiraglio tra gli alberi — ancora qualche passo e sarai al sicuro.",
      badDescription1:
        "Attraversi una foresta che sembra sul punto di vomitarti addosso qualche orrore nascosto. Per fortuna scorgi già uno spiraglio tra gli alberi — ancora qualche passo e sarai al sicuro.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Crossing: {
      name: "Attraversamento a Nuoto",
      effect: "toss/toss",
      protection: "breathing-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 11,
      badKarma2: 11,
      badKarma3: 22,
      badKarma4: 22,
      badKarma5: 6,
      badKarma6: 5,
      worseKarma1: 11,
      worseKarma2: 11,
      worseKarma3: 11,
      worseKarma4: 11,
      worseKarma5: 22,
      worseKarma6: 6,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      badDescription2:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      badDescription3:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Attraversarlo è una sfida persino per un’eroə come te. Tossendo e ingoiando acqua, arrivi alla riva con le ultime forze. Ti senti scampatə alla morte, e sai che non sarai mai più spensieratə come prima.",
      badDescription4:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Attraversarlo è una sfida persino per un’eroə come te. Tossendo e ingoiando acqua, arrivi alla riva con le ultime forze. Ti senti scampatə alla morte, e sai che non sarai mai più spensieratə come prima.",
      badDescription5:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Ingoi acqua innumerevoli volte, ma alla fine riesci ad arrivare sull’altra riva. Respiri a lungo e il tuo respiro ora è un po’ rauco. Pensavi che sarebbe stato più facile.",
      badDescription6:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Ingoi acqua innumerevoli volte, ma alla fine riesci ad arrivare sull’altra riva.  Pensavi che sarebbe stato più facile.",
      worseDescription1:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      worseDescription2:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      worseDescription3:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      worseDescription4:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Cerchi ancora di prendere un ultimo sorso d’aria, ma sopra di te c’è ormai solo acqua. Ansimando, affondi, mentre i polmoni bruciano invasi dall’acqua. Qualcuno sulla riva grida che serve aiuto. Ti hanno salvato, ma il tuo corpo non è più lo stesso. Ti muovi un po’ più lentamente, ogni cosa richiede ora più tempo.",
      worseDescription5:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Attraversarlo è una sfida persino per un’eroə come te. Tossendo e ingoiando acqua, arrivi alla riva con le ultime forze. Ti senti scampatə alla morte, e sai che non sarai mai più spensieratə come prima.",
      worseDescription6:
        "Il fiume, benché sembri tranquillo, è estremamente insidioso. Ingoi acqua innumerevoli volte, ma alla fine riesci ad arrivare sull’altra riva. Respiri a lungo e il tuo respiro ora è un po’ rauco. Pensavi che sarebbe stato più facile.",
    },
    Dragon: {
      name: "Drago",
      effect: "display",
      protection: "antiflame-spell",
      protectedKarma: 4,
      badKarma1: 12,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Passi vicino a una caverna di drago, svegliandone il padrone. Il drago striscia fuori dalla tana e soffia fuoco su tutta la zona.",
      badDescription1:
        "Passi vicino a una caverna di drago, svegliandone il padrone. Il drago striscia fuori dalla tana e soffia fuoco su tutta la zona.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Appiary: {
      name: "Vecchio Apiario",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 13,
      badKarma2: 2,
      badKarma3: 2,
      badKarma4: 2,
      badKarma5: 20,
      badKarma6: 20,
      worseKarma1: 13,
      worseKarma2: 13,
      worseKarma3: 13,
      worseKarma4: 2,
      worseKarma5: 2,
      worseKarma6: 2,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Hai fatto infuriare delle api mutate e velenose. Eri il più vicino, quindi sei statə colpitə più duramente. Gonfiə e malconciə, hai un aspetto davvero orribile. E come se non bastasse, le api sono uscite dagli alveari e pungono chiunque nella regione. D’ora in poi, per non morire, tuttə dovranno preparare ogni mattina un antidoto che richiede tempo.",
      badDescription2:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      badDescription3:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      badDescription4:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      badDescription5:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      badDescription6:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      worseDescription1:
        "Hai fatto infuriare delle api mutate e velenose. Eri il più vicino, quindi sei statə colpitə più duramente. Gonfiə e malconciə, hai un aspetto davvero orribile. E come se non bastasse, le api sono uscite dagli alveari e pungono chiunque nella regione. D’ora in poi, per non morire, tuttə dovranno preparare ogni mattina un antidoto che richiede tempo.",
      worseDescription2:
        "Hai fatto infuriare delle api mutate e velenose. Eri il più vicino, quindi sei statə colpitə più duramente. Gonfiə e malconciə, hai un aspetto davvero orribile. E come se non bastasse, le api sono uscite dagli alveari e pungono chiunque nella regione. D’ora in poi, per non morire, tuttə dovranno preparare ogni mattina un antidoto che richiede tempo.",
      worseDescription3:
        "Hai fatto infuriare delle api mutate e velenose. Eri il più vicino, quindi sei statə colpitə più duramente. Gonfiə e malconciə, hai un aspetto davvero orribile. E come se non bastasse, le api sono uscite dagli alveari e pungono chiunque nella regione. D’ora in poi, per non morire, tuttə dovranno preparare ogni mattina un antidoto che richiede tempo.",
      worseDescription4:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      worseDescription5:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
      worseDescription6:
        "Hai fatto infuriare le api. Sono volate fuori dall’alveare e ti pungono tutto il viso. Gonfiə come sei, l’aspetto è davvero terribile.",
    },
    Slippery: {
      name: "Scivoloso",
      effect: "display/toss",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 14,
      badKarma2: 23,
      badKarma3: 23,
      badKarma4: 23,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Il sentiero è davvero in pessime condizioni, ma per fortuna eviti di scivolare.",
      badDescription1:
        "Il sentiero è davvero in pessime condizioni, e purtroppo scivoli. Nulla di grave: hai solo perso il resto del movimento cercando di rimetterti in piedi. Inoltre zoppichi leggermente per un po’.",
      badDescription2:
        "Il sentiero è davvero in pessime condizioni, e purtroppo scivoli. Nulla di serio, ma zoppichi leggermente per un po’. Puoi andare a farti vedere da unə medicə OPPURE stringere i denti e proseguire – in fondo è solo una botta.",
      badDescription3:
        "Il sentiero è davvero in pessime condizioni, e purtroppo scivoli. Nulla di serio, ma zoppichi leggermente per un po’. Puoi andare a farti vedere da unə medicə OPPURE stringere i denti e proseguire – in fondo è solo una botta.",
      badDescription4:
        "Il sentiero è davvero in pessime condizioni, e purtroppo scivoli. Nulla di serio, ma zoppichi leggermente per un po’. Puoi andare a farti vedere da unə medicə OPPURE stringere i denti e proseguire – in fondo è solo una botta.",
      badDescription5:
        "Il sentiero è davvero in pessime condizioni, ma per fortuna eviti di scivolare.",
      badDescription6:
        "Il sentiero è davvero in pessime condizioni, ma per fortuna eviti di scivolare.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Wilderness: {
      name: "Luogo Sacro",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 15,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Si dice che nel luogo sacro danzino le driadi, attirando i viandanti col canto. Potrebbe essere interessante, ma non ti arriva nessun suono. Un po’ delusə, prosegui.",
      badDescription1:
        "Attraversando il luogo sacro senti un canto allegro e ammaliante. In fondo, un po’ di musica non ha mai ucciso nessunə. Vai avanti e ti accorgi che la melodia ti è rimasta addosso – non riesci a smettere di canticchiarla.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Volcano: {
      name: "Vulcano",
      effect: "toss/toss",
      protection: "antiflame-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 16,
      badKarma2: 16,
      badKarma3: 10,
      badKarma4: 10,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: 24,
      worseKarma2: 24,
      worseKarma3: 16,
      worseKarma4: 16,
      worseKarma5: 10,
      worseKarma6: 10,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      badDescription2:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      badDescription3:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Ti aggrappi a un masso e riesci a risalire, ma ti ferisci le mani.",
      badDescription4:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Ti aggrappi a un masso e riesci a risalire, ma ti ferisci le mani.",
      badDescription5:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi, ma riesci a mantenere l’equilibrio.",
      badDescription6:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi, ma riesci a mantenere l’equilibrio.",
      worseDescription1:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      worseDescription2:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      worseDescription3:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      worseDescription4:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Per evitare di cadere nella lava, ti aggrappi a un masso dalla superficie tagliente. Riesci a risalire, ma ti ferisci alle mani, e in più qualche spruzzo di lava ti brucia la pelle del viso.",
      worseDescription5:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Ti aggrappi a un masso e riesci a risalire, ma ti ferisci le mani.",
      worseDescription6:
        "Il sentiero costeggia il cratere. Mentre lo percorri, il terreno ti frana sotto i piedi. Ti aggrappi a un masso e riesci a risalire, ma ti ferisci le mani.",
    },
  },
};
